import React, { useEffect, useState } from 'react';
import { Container, makeStyles } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import Page from '../../../components/Layout/Page';
import SplashScreen from '../../../components/Loading/SplashScreen';
import ZipiTip from './ZipiTip';
import KpiGrid from './KpiGrid';
// import AlertStrip from './AlertStrip';
import TopProductsPanel from './TopProductsPanel';
import WeeklyChartPanel from './WeeklyChartPanel';
import PaymentPanel from './PaymentPanel';
import StoreSalesPanel from './StoreSalesPanel';
import resumenRequest from '../../../requests/api/resume';
import handleApiResponse from '../../../utils/handleApiResponse';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  panelsGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: 12,
    '@media (min-width: 900px)': {
      gridTemplateColumns: '1.4fr 1fr',
    },
  },
  rightCol: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },
}));

export default function ResumenView() {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const account = useSelector((s) => s.account);
  const [resumen, setResumen] = useState(null);

  useEffect(() => {
    const fetchResumen = async () => {
      try {
        const response = await resumenRequest.getResumen(account.user.clientId);
        if (response.success) {
          setResumen(response.data);
        }
      } catch (err) {
        handleApiResponse(enqueueSnackbar, err, false);
      }
    };
    if (account.user.clientId) fetchResumen();
  }, [account.user.clientId]);

  if (!resumen) return <SplashScreen />;

  const {
    zipiMessage, kpis, topProductos, ventasSemana, pagos, ventasPorLocal,
  } = resumen;

  return (
    <Page className={classes.root} title="Resumen">
      <Container maxWidth={false}>
        <ZipiTip message={zipiMessage} />
        <KpiGrid kpis={kpis} />
        {/* <AlertStrip alertasStock={kpis.alertasStock} /> */}
        <div className={classes.panelsGrid}>
          <TopProductsPanel productos={topProductos} clientId={account.user.clientId} />
          <div className={classes.rightCol}>
            <WeeklyChartPanel dias={ventasSemana} />
            <PaymentPanel pagos={pagos} clientId={account.user.clientId} />
            <StoreSalesPanel ventasPorLocal={ventasPorLocal} clientId={account.user.clientId} />
          </div>
        </div>
      </Container>
    </Page>
  );
}
